export default function fadeOut(el, duration = 200, updateTabIndex = false, addAriaHidden = false) {
	if (!el) {
		return;
	}

	el.style.opacity = 1;
	el.style.transition = `opacity ${duration}ms`;
	el.style.opacity = 0;

	if (updateTabIndex) {
		el.setAttribute('tabindex', '-1');
	}
	if (addAriaHidden) {
		el.setAttribute('aria-hidden', true);
	}

	window.setTimeout(function() {
		el.style.display = 'none';
	}, duration);
}
